/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ResourceControllerCountStudentsInPhase$Params {
  ilsId: string;
  phaseId: string;
}

export function resourceControllerCountStudentsInPhase(http: HttpClient, rootUrl: string, params: ResourceControllerCountStudentsInPhase$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, resourceControllerCountStudentsInPhase.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.path('phaseId', params.phaseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

resourceControllerCountStudentsInPhase.PATH = '/resources/countStudents/{ilsId}/{phaseId}';
